import { Component } from "react"
import DatePicker from "components/ui/DatePicker"
import TypeSelectionDropdown from "./type_selection"
import {
  ageInMonthsAtTimeOfEvent,
  meetsAttendeeTypeAgeRestriction,
  reformatDate
} from "utils/age_restriction_utils"
import PropTypes from "prop-types"
import RegistrationsPropTypes from "utils/prop_types"
import { colors } from "components/shared/church_center_colors"
import moment from "moment-timezone"
import { date } from "@churchcenter/datetime-fmt"
import { gendersMatch } from "utils/genders_match"

class ExistingAttendeeListItem extends Component {
  constructor(props) {
    super(props)

    const {
      checked,
      attendeeSelection: { age, birthdate, gender, grade }
    } = this.props
    const gradeValue = Number.isInteger(grade) ? grade : ""

    this.state = {
      checked,
      attendeeTypeId: "",
      gender: gender || "",
      grade: gradeValue,
      age: age || "",
      birthdate: birthdate ? reformatDate(birthdate) : "",
      initialGrade: gradeValue,
      initialGender: gender || "",
      initialBirthdate: birthdate ? reformatDate(birthdate) : ""
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    const { onChange, attendeeSelection } = this.props
    if (this.state !== prevState) {
      onChange({
        personId: attendeeSelection.personId,
        ...this.state
      })
    }
  }

  checkAge(attendeeType) {
    const { birthdate } = this.state
    const evaluateAgeAt = attendeeType.evaluateAgeAt
      ? attendeeType.evaluateAgeAt
      : this.props.eventStartDate

    return meetsAttendeeTypeAgeRestriction(attendeeType, birthdate, evaluateAgeAt)
      ? null
      : this.ageRestrictionText(attendeeType)
  }

  ageRestrictionText(attendeeType) {
    let evaluateAgeAtText = attendeeType.evaluateAgeAt
      ? date(attendeeType.evaluateAgeAt)
      : "event start date"
    let ageRestrictionUnitText = attendeeType.ageRestrictionUnit === 1 ? "year" : "month"
    if (attendeeType.minAge == null && attendeeType.maxAge != null) {
      if (attendeeType.maxAge === 1) {
        return `at most ${attendeeType.maxAge} ${ageRestrictionUnitText} old by ${evaluateAgeAtText}`
      } else {
        return `at most ${attendeeType.maxAge} ${ageRestrictionUnitText}s old by ${evaluateAgeAtText}`
      }
    } else if (attendeeType.minAge != null && attendeeType.maxAge == null) {
      if (attendeeType.minAge === 1) {
        return `at least ${attendeeType.minAge} ${ageRestrictionUnitText} old by ${evaluateAgeAtText}`
      } else {
        return `at least ${attendeeType.minAge} ${ageRestrictionUnitText}s old by ${evaluateAgeAtText}`
      }
    } else if (attendeeType.minAge === attendeeType.maxAge) {
      if (attendeeType.maxAge === 1) {
        return `${attendeeType.minAge} ${ageRestrictionUnitText} old by ${evaluateAgeAtText}`
      } else {
        return `${attendeeType.minAge} ${ageRestrictionUnitText}s old by ${evaluateAgeAtText}`
      }
    } else {
      return `${attendeeType.minAge} - ${attendeeType.maxAge} ${ageRestrictionUnitText} olds by ${evaluateAgeAtText}`
    }
  }

  checkGrade(grade, attendeeType) {
    let minGrade = attendeeType.minGrade
    let maxGrade = attendeeType.maxGrade
    if (grade === "") {
      return this.gradeRestrictionText(attendeeType)
    }
    if (minGrade == null) {
      minGrade = -1
    }
    if (maxGrade == null) {
      maxGrade = 12
    }
    return minGrade <= grade && grade <= maxGrade ? null : this.gradeRestrictionText(attendeeType)
  }

  gradeRestrictionText(attendeeType) {
    if (attendeeType.minGrade == null && attendeeType.maxGrade != null) {
      return `all grades up to ${attendeeType.maxGradeToS} grade only`
    } else if (attendeeType.minGrade != null && attendeeType.maxGrade == null) {
      return `${attendeeType.minGradeToS} grade and up`
    } else if (attendeeType.minGrade === attendeeType.maxGrade) {
      return `${attendeeType.minGradeToS} grade only`
    } else {
      return `${attendeeType.minGradeToS} - ${attendeeType.maxGradeToS} grade only`
    }
  }

  checkGender(gender, attendeeType) {
    return gendersMatch(attendeeType.genderRestrictionUnit, gender)
      ? null
      : this.genderRestrictionText(attendeeType)
  }

  genderRestrictionText(attendeeType) {
    return attendeeType.genderRestrictionUnit === ""
      ? null
      : `${attendeeType.genderRestrictionUnit === "M" ? "males" : "females"} only`
  }

  render() {
    const {
      attendeeSelection,
      attendeeTypes,
      currentPersonVerified,
      genderOptions,
      gradeOptions,
      eventStartDate,
      mobileBrowser,
      currentRegistrationUrl
    } = this.props

    const {
      avatarUrl,
      key,
      personId,
      name,
      gender,
      grade,
      age,
      birthdate,
      firstName,
      isRegisteredForEvent,
      isCurrentPerson
    } = attendeeSelection

    const { checked, attendeeTypeId, initialBirthdate, initialGender, initialGrade } = this.state
    const attendeeType = attendeeTypes.find(t => t.id === attendeeTypeId)

    return (
      <div className="action-drawer mb-1" css={{ zIndex: this.props.zValue }}>
        <div className={`${checked ? "pb-0" : ""}`}>
          <div className="d-f p-r">
            <input
              type="checkbox"
              className="large-checkbox checkbox"
              name={key}
              id={key}
              checked={checked}
              onChange={this.handleCheckboxClick}
            />
            <label
              htmlFor={key}
              className="large-checkbox-label checkbox-label p-s w-100%"
              css={{
                paddingLeft: 32,
                "&:before": { top: "19px !important" },
                "&:after": { top: "22px !important" }
              }}
            >
              <div className={`d-f ${!isRegisteredForEvent && "ai-c"}`}>
                <div className="mr-1">
                  <img src={avatarUrl} alt={name} className="w-7 h-7 circle" />
                </div>
                <div className="f-1">
                  {name}
                  {isRegisteredForEvent && (
                    <div className="warning-alert alert fs-4 mb-0 mt-1 p-1">
                      {firstName} has already registered.{" "}
                      {isCurrentPerson && currentRegistrationUrl && (
                        <a
                          css={{
                            color: colors.tint1,
                            textDecoration: "underline"
                          }}
                          href={currentRegistrationUrl}
                        >
                          View registration
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </label>
          </div>
          <div className="pl-4">
            <div className={`pt-2 pb-1 ${checked ? "" : "d-n"}`}>
              <TypeSelectionDropdown
                eventStartDate={eventStartDate}
                attendeeGender={gender}
                attendeeGrade={grade}
                attendeeAge={age}
                isOpen={false}
                attendeeTypeId={attendeeTypeId}
                attendeeTypes={attendeeTypes}
                attendee={attendeeSelection}
                onChange={this.handleChange}
                zValue={this.props.zValue}
                currentPersonVerified={currentPersonVerified}
              />
            </div>
            {checked && attendeeType && !initialBirthdate && attendeeType.hasAgeRestrictions && (
              <div className="mt-1">
                <label className="label fw-500">Birthdate</label>
                <DatePicker
                  datetime={birthdate}
                  onChange={date =>
                    this.props.onChange({
                      personId,
                      checked,
                      age: ageInMonthsAtTimeOfEvent(
                        moment(date).format(momentDateFormat),
                        attendeeType.evaluateAgeAt ? attendeeType.evaluateAgeAt : eventStartDate
                      ),
                      birthdate: date
                    })
                  }
                  disabled={!checked}
                  toMonth={new Date()}
                />
                {this.checkAge(attendeeType) && (
                  <em className="fs-13 c-tint2 p-r pl-1">{this.checkAge(attendeeType)}</em>
                )}
              </div>
            )}
            {checked && !initialGender && attendeeType && attendeeType.hasGenderRestrictions && (
              <div className="mt-1">
                <label className="label fw-500">Gender</label>
                <select
                  className="select w-a"
                  value={gender}
                  disabled={!checked}
                  onChange={e =>
                    this.props.onChange({
                      personId,
                      checked,
                      gender: e.target.value
                    })
                  }
                >
                  {genderOptions.map(([key, value]) => (
                    <option key={key} value={value}>
                      {key}
                    </option>
                  ))}
                </select>
                {this.checkGender(gender, attendeeType) && (
                  <em className="fs-13 c-tint2 p-r pl-1">
                    {this.checkGender(gender, attendeeType)}
                  </em>
                )}
              </div>
            )}
            {checked &&
              !Number.isInteger(initialGrade) &&
              attendeeType &&
              attendeeType.hasGradeRestrictions && (
                <div className="mt-1">
                  <label className="label fw-500">Grade</label>
                  <select
                    name="attendee_type[min_grade]"
                    id="attendee_type_min_grade"
                    className="select w-a"
                    value={grade}
                    disabled={!checked}
                    onChange={e =>
                      this.props.onChange({
                        personId,
                        checked,
                        grade: e.target.value
                      })
                    }
                  >
                    {gradeOptions.map(([key, value]) => (
                      <option key={key} value={value}>
                        {key}
                      </option>
                    ))}
                  </select>
                  {this.checkGrade(grade, attendeeType) && (
                    <em className="fs-13 c-tint2 p-r pl-1">
                      {this.checkGrade(grade, attendeeType)}
                    </em>
                  )}
                </div>
              )}
          </div>
        </div>
      </div>
    )
  }

  handleChange(attendeeTypeId, checked) {
    checked = checked === undefined ? !this.state.checked : checked

    if (checked) this.handleCheckboxClick()
    this.setState({ attendeeTypeId })
  }

  handleCheckboxClick(e) {
    if (e.target.localName === "a") {
      return
    }

    const { age, birthdate, gender, grade } = this.state
    const {
      onChange,
      attendeeSelection: { personId }
    } = this.props

    const checked = !this.state.checked
    const attendeeTypeId = checked ? this.state.attendeeTypeId : ""

    onChange({
      age,
      birthdate,
      checked,
      gender,
      grade,
      personId
    })

    this.setState({ checked, attendeeTypeId })
  }
}

ExistingAttendeeListItem.propTypes = {
  attendeeSelection: RegistrationsPropTypes.AttendeeSelection.isRequired,
  attendeeTypes: PropTypes.arrayOf(RegistrationsPropTypes.AttendeeType).isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  eventStartDate: PropTypes.string
}

export default ExistingAttendeeListItem
